import type { IProductionStatementCreationJob } from "@/interfaces/api/production-statement-creation-job.interface"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import { BaseRepository } from "@/repositories/base-repository"
import DataHelper from "@/helper/data-helper"

export class ProductionStatementCreationJobRepository extends BaseRepository<IProductionStatementCreationJob> {
  protected resourcePath = "administration/production-statement-creation-jobs"

  public async restartBatch(batchId: string): Promise<IProductionStatementCreationJob[]> {
    const response = await new HTTPRequestBuilder(
      HTTPMethods.POST,
      `administration/production-statement-creation-batches/${batchId}/restart/`
    )
      .setExpectedStatusCode(202)
      .build()
      .execute()

    return DataHelper.denormalizeData(response.data) as IProductionStatementCreationJob[]
  }

  public async rollback(job: IProductionStatementCreationJob): Promise<void> {
    await new HTTPRequestBuilder(HTTPMethods.POST, `${this.resourcePath}/${job.id}/rollback/`)
      .setExpectedStatusCode(204)
      .build()
      .execute()
  }
}
